<section
  class="products-filters"
  [class.products-filters--dialog]="layoutVariant() === 'dialog'">
  @if (
    layoutVariant() !== 'dialog' &&
    categoriesService.isCategoriesDataLoading() &&
    (categoriesTypesFilters || []).length === 0
  ) {
    <div class="products-filters-skeleton" aria-hidden="true">
      <div class="products-filters-skeleton__section">
        <ngx-skeleton-loader
          count="1"
          [theme]="{
            width: '5rem',
            height: '0.875rem',
            'border-radius': '0.25rem',
            margin: '0 0 0.75rem 0',
          }"></ngx-skeleton-loader>
        @for (line of [1, 2, 3]; track line) {
          <ngx-skeleton-loader
            count="1"
            class="products-filters-skeleton__option"
            [theme]="{
              width: line === 3 ? '65%' : '88%',
              height: '0.875rem',
              'border-radius': '0.25rem',
              margin: '0 0 0.625rem 0',
            }"></ngx-skeleton-loader>
        }
      </div>

      <div
        class="products-filters-skeleton__section products-filters-skeleton__section--divider">
        <ngx-skeleton-loader
          count="1"
          [theme]="{
            width: '3.5rem',
            height: '0.875rem',
            'border-radius': '0.25rem',
            margin: '0 0 0.75rem 0',
          }"></ngx-skeleton-loader>
        @for (line of [1, 2]; track line) {
          <ngx-skeleton-loader
            count="1"
            class="products-filters-skeleton__option"
            [theme]="{
              width: line === 2 ? '58%' : '82%',
              height: '0.875rem',
              'border-radius': '0.25rem',
              margin: '0 0 0.625rem 0',
            }"></ngx-skeleton-loader>
        }
      </div>

      <div class="products-filters-skeleton__footer">
        <ngx-skeleton-loader
          count="1"
          [theme]="{
            width: '7.5rem',
            height: '0.875rem',
            'border-radius': '0.25rem',
            margin: '0',
          }"></ngx-skeleton-loader>
      </div>
    </div>
  } @else {
  <!-- product types filters -->
  @if ((categoriesTypesFilters || []).length > 0) {
    <pwj-filters-box
      boxTitle="products.category"
      boxIcon="grid-apps-2"
      filterQueryName="category_type_id"
      filtersType="radioButton"
      [dialogLayout]="layoutVariant() === 'dialog'"
      [panelVariant]="filtersBoxPanelVariant()"
      [filterItems]="categoriesTypesFilters"></pwj-filters-box>
  }

  <!-- product forms filters -->
  @if (categoriesFilters && (categoriesFilters || []).length > 0) {
    <pwj-filters-box
      boxTitle="products.type"
      boxIcon="grid-apps"
      filterQueryName="category_id"
      filtersType="radioButton"
      [dialogLayout]="layoutVariant() === 'dialog'"
      [panelVariant]="filtersBoxPanelVariant()"
      [filterItems]="categoriesFilters"></pwj-filters-box>
  }

  <!-- product categories filters -->
  @if (subCategoriesFilters && (subCategoriesFilters || []).length > 0) {
    <pwj-filters-box
      boxTitle="products.productName"
      boxIcon="grid-apps"
      filterQueryName="sub_category_id"
      filtersType="checkbox"
      [dialogLayout]="layoutVariant() === 'dialog'"
      [panelVariant]="filtersBoxPanelVariant()"
      [filterItems]="subCategoriesFilters"
      [isCategoryFiltering]="true"></pwj-filters-box>
  }

  @if (
    selectedCategory === 'NATURAL_STONE' ||
    selectedCategory === 'ARTIFICIAL_STONE'
  ) {
    <!-- color filters -->
    <pwj-filters-box
      boxTitle="products.color"
      boxIcon="brush-4"
      filterQueryName="metadata[main_color]"
      filtersType="checkbox"
      [dialogLayout]="layoutVariant() === 'dialog'"
      [panelVariant]="filtersBoxPanelVariant()"
      [filterItems]="colorFilters"
      filterPrefix="enums.colors."
      (onApplyFilters)="
        applyFilter($event, 'metadata[main_color]')
      "></pwj-filters-box>

    <!-- Stone surface processing filters -->
    <pwj-filters-box
      boxTitle="products.stoneSurfaceFinishing"
      boxIcon="3d-cube"
      filterQueryName="metadata[surface_finishing]"
      filtersType="checkbox"
      [dialogLayout]="layoutVariant() === 'dialog'"
      [panelVariant]="filtersBoxPanelVariant()"
      [filterItems]="surfaceFinishingFilters"
      filterPrefix="enums.stoneSurfaceFinishing."
      (onApplyFilters)="
        applyFilter($event, 'metadata[surface_finishing]')
      "></pwj-filters-box>

    <!-- stone design filters -->
    <pwj-nested-filters-box
      boxTitle="products.designOnStone"
      boxIcon="3d-cube"
      filterPrefix="enums.colors."
      filtersType="checkbox"
      [nestedFilterItems]="stoneDesignFilters"
      (onApplyFilters)="
        applyFilter($event, null, false, true)
      "></pwj-nested-filters-box>

    <!-- stone grade filters -->
    <pwj-filters-box
      boxTitle="products.stoneGrade"
      boxIcon="ranking-1"
      filterQueryName="metadata[stone_grade]"
      filtersType="checkbox"
      [dialogLayout]="layoutVariant() === 'dialog'"
      [panelVariant]="filtersBoxPanelVariant()"
      [filterPrefix]="'products.grade' | translate"
      [filterItems]="stoneGradeFilters"
      (onApplyFilters)="
        applyFilter($event, 'metadata[stone_grade]')
      "></pwj-filters-box>
  }

  @if (
    selectedCategory === 'NATURAL_STONE' ||
    selectedCategory === 'ARTIFICIAL_STONE'
  ) {
    <!-- climatic effects filters-->
    <pwj-climatic-filters-box
      boxTitle="products.specifications"
      boxIcon="cloud-notif"
      filtersType="staged"
      [climaticFilters]="climaticFilters"></pwj-climatic-filters-box>
  }
  }
</section>
